// extracted by mini-css-extract-plugin
export default {"banner":"Signup_banner__oVcfo","formContainer":"Signup_formContainer__-zXxI"};